import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-brand-forms',
  templateUrl: './add-brand-forms.component.html',
  styleUrls: ['./add-brand-forms.component.css']
})
export class AddBrandFormsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
